import { render, staticRenderFns } from "./Propinas.vue?vue&type=template&id=0e6096c2&"
import script from "./Propinas.vue?vue&type=script&lang=js&"
export * from "./Propinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports